import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { FilterSettingsModel, IFilter, GridComponent, QueryCellInfoEventArgs, DataStateChangeEventArgs, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { PayorRequiredIDBO, IsViewEditpayorequired, functionpermission, GetpayeridBO, columnWidth, ColumnChangeBO } from '../employee.model';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { GlobalComponent } from 'src/app/global/global.component';
import { EmployeeService } from '../employee.service';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { GetEmployeeservice } from '../employeedata.service';
import { EmployeeDataService } from './payor-required-ids.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
  selector: 'app-payor-required-ids-list',
  templateUrl: './payor-required-ids-list.component.html',
  styleUrls: ['./payor-required-ids-list.component.scss']
})
export class PayorRequiredIdsListComponent implements OnInit {
   private onDestroy$: Subject<void> = new Subject<void>();

  // constructor() { }

  public formatOptions: object;
  payorRequiredIdLst: PayorRequiredIDBO[];
  EmployeeId: string;
  @Input() employeeId: string;
  @Output() IsViewEditpayorequired = new EventEmitter<IsViewEditpayorequired>()
  @ViewChild('grid') public grid: GridComponent;
  initialPage: object;
  arraycol: any = [];
  filterOptions: FilterSettingsModel;
  fp: functionpermission = new functionpermission();
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ListBO: GetpayeridBO = new GetpayeridBO();
  public data: Observable<DataStateChangeEventArgs>;
  id: number = 0;
  deleteid:any;
  filter: IFilter;
  public filterSettings: object;
  public formatOptions1: object;
  public wrapSettings: TextWrapSettingsModel;

  constructor(public EmployeeService: EmployeeService, public datepipe: DatePipe, public toastrService: ToastrService,private ngxService: NgxUiLoaderService,
     public global: GlobalComponent, private ref: ChangeDetectorRef, @Inject(GetEmployeeservice) public EmployeeRequest: GetEmployeeservice) {
    this.global.checkforlogout();
    // ref.detach();
    // setInterval(() => {
    //   this.ref.detectChanges();
    // }, 100);
    this.data = EmployeeRequest;
  }
  
  ngOnInit() {
  
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.wrapSettings = { wrapMode: 'Content' };
    this.filterOptions = { type: 'Excel' };
    this.filterSettings = { type: 'Menu' };
    this.formatOptions1 = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };
    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    this.getPayorRequiredId()
   this.getpermission()

  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.EmployeeService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  // getpermission() {
  //   let params = new URLSearchParams();
  //   // let url = "api/functionpermisssion/getfunctionpermissionemployee?";
  //   params.append("pagecode", "Employee");
  //   params.append("roleId", this.global.roleId);
  //   params.append("agencyId", this.global.globalAgencyId)
  //   this.EmployeeService.getEmployeepermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

  //     if (data != null) {
  //       this.fp = data;

  //     }
  //     else {
  //       this.fp = new functionpermission();
  //     }
  //   },
  //     (err: HttpErrorResponse) => {
  //       this.fp = new functionpermission();
  //     })
  // }

  // onResize(args) {

  //   const column = this.grid.getColumnByField(args.column.field)
  //   column.width = args.column.width;
  //   this.ColumnArray.forEach(element => {
  //     if (element.column == column.headerText) {
  //       element.width = parseInt(column.width.toString());
  //     }

  //   });
  // //  this.SaveColumnwidth();
  // }

  editPayorRequiredId(type, edit) {

    if (type == 'new') {
      this.IsViewEditpayorequired.emit({ isView: false, isEdit: true, isEditPayorRequired: false, employeeId: this.employeeId, payorRequiredId: '00000000-0000-0000-0000-000000000000', payorRequired: this.payorRequiredIdLst, payorActiotype: 'create' })
    }
    else if (type == 'edit') {
      this.IsViewEditpayorequired.emit({ isView: false, isEdit: true, isEditPayorRequired: true, employeeId: this.employeeId, payorRequiredId: edit.id, payorRequired: this.payorRequiredIdLst, payorActiotype: 'edit' })
    }
    else {
      this.IsViewEditpayorequired.emit({ isView: false, isEdit: true, isEditPayorRequired: true, employeeId: this.employeeId, payorRequiredId: edit.id, payorRequired: this.payorRequiredIdLst,payorActiotype: 'delete' })
    }

  }

   ///////////////////////////////////////get payorRequiredData//////////////////////////////////////////////////////////////
   getPayorRequiredId() {
    let params = new URLSearchParams();
    params.append("EmployeeID", this.employeeId);
    this.ListBO.employeeID = this.employeeId;
    this.EmployeeRequest.executepayerId(this.ListBO)
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
      this.payorRequiredIdLst = datas.result;
      if (datas.count > 0) {
        
        count++;
        // if (datas != null && datas != undefined && count == 1) {
        //   this.getColumnwidth();
        // }
        this.payorRequiredIdLst.forEach(element => {
         
          element.startDate = this.datepipe.transform(element.startDate, "MM/dd/yyyy")
          element.endDate = this.datepipe.transform(element.endDate, "MM/dd/yyyy")
         
        })
       
     }
    });

  }

  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);

    this.ColumnArray = this.arraycol[0].Payor_required_ids.Columns;

    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }

    if (this.grid != undefined) {
      this.grid.pageSettings.pageSize = this.arraycol[0].Payor_required_ids.Pagesize;
      this.ColumnArray.forEach(element => {



        if (element.column == 'Payors') {

          const column = this.grid.getColumnByField('payorName'); // get the JSON object of the column corresponding to the field name
          // column.headerText = element.column;
          column.width = element.width;

          this.grid.refreshHeader();
          //this.grid.refreshColumns();
        }
        if (element.column == 'ID Number') {

          const column1 = this.grid.getColumnByField('billingPayorRequiredID'); // get the JSON object of the column corresponding to the field name

          column1.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'Start Date') {

          const column1 = this.grid.getColumnByField('startDate'); // get the JSON object of the column corresponding to the field name

          column1.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'End Date') {

          const column1 = this.grid.getColumnByField('endDate'); // get the JSON object of the column corresponding to the field name

          column1.width = element.width;

          this.grid.refreshHeader();
        }

        if (element.column == 'Fax Date') {

          const column1 = this.grid.getColumnByField('faxDate'); // get the JSON object of the column corresponding to the field name

          column1.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'Received') {

          const column1 = this.grid.getColumnByField('received'); // get the JSON object of the column corresponding to the field name

          column1.width = element.width;

          this.grid.refreshHeader();
        }

      });
    }
  }

  SaveColumnwidth() {
    this.arraycol[0].Payor_required_ids.Columns = this.ColumnArray;
    this.arraycol[0].Payor_required_ids.Pagesize = this.grid.pageSettings.pageSize;

    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;

    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.EmployeeService.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //  this.getColumnwidth();
    });
  }

  //============================== Tooltip =========================================================//
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }

  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  //========================= evnt change =====================================================================//
  public dataStateChange(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListBO.orderColumn = "PayorName";
        this.ListBO.orderType = 'asc';

      }
    }
    if (this.ListBO.type == "date") {
      this.ListBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      this.ListBO.field = state.action.currentFilterObject.field;
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      this.ListBO.field = state.action.currentFilterObject.field;
      this.ListBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListBO.operator = state.action.currentFilterObject.operator;
      this.ListBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.ListBO.field = "PayorName";
        this.ListBO.matchCase = false;
        this.ListBO.operator = "contains";
        this.ListBO.value = "";
        this.ListBO.type = "string"
     //   this.ListBO.clientId = this.global.clientId;
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Payor_required_ids.Pagesize != state.take) {
          this.arraycol[0].Payor_required_ids.Pagesize = state.take
         // this.SaveColumnwidth();
          // }

        }

      }

    }
    this.getPayorRequiredId();
  }


  setDeleteId(value) {
    this.deleteid = value;  
    }

  public onActionComplete(args) {

    this.ListBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;

    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ListBO.type = args.columnType
    }

  }


  deletepayor() {
    let params = new URLSearchParams();
    params.append("payorId", this.deleteid);
    this.EmployeeService.deletepayorReqiured(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success('Employee PayorRequiredId deleted successfully!');
      this.getPayorRequiredId();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);

    },
      (err: HttpErrorResponse) => {
        this.toastrService.error(
          err.error,
          'Error');
      })
  }

}
